export var padZero = function (value) {
    if (value < 10) {
        return "0".concat(value);
    }
    return value;
};
